import {
  fetchOfferSearchStart,
  fetchOfferSearchSuccess,
  fetchOfferSearchFailure,
} from "./reducer";

import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { GET_ALL_OFFER_SEARCH } from "../../constants/constants";

export const getAllOfferSearch =
  (partnerId, offerTitle = "", setLoading) =>
  async (dispatch) => {
    try {
      setLoading?.(true);

      dispatch(fetchOfferSearchStart());

      const response = await determineBaseUrlAndPerformApiCall(
        GET_ALL_OFFER_SEARCH(partnerId, offerTitle),
        "GET"
      );

      dispatch(fetchOfferSearchSuccess(response));

      setLoading?.(false);
    } catch (error) {
      setLoading?.(false);

      dispatch(fetchOfferSearchFailure(error.message));
    }
  };